import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const AUTOHIDE_DURATION_IN_MILLISECONDS = 7000;

export interface Snackbar {
  message: string;
  type?: "error" | "success" | "warning" | "info";
  vertical?: "top" | "bottom";
  horizontal?: "left" | "center" | "right";
}

export interface SnackbarState extends Snackbar {
  open: boolean;
  autoHideDuration: number;
}

const initialState: SnackbarState = {
  open: false,
  message: "",
  type: "info",
  vertical: "top",
  horizontal: "right",
  autoHideDuration: AUTOHIDE_DURATION_IN_MILLISECONDS,
};

const snackbarSlice = createSlice({
  name: "snackbar",
  initialState: initialState,
  reducers: {
    openSnackbar(state, action: PayloadAction<Snackbar>) {
      state.open = true;
      state.message = action.payload.message;
      state.type = action.payload.type;
      state.vertical = action.payload.vertical;
      state.horizontal = action.payload.horizontal;
      state.autoHideDuration = AUTOHIDE_DURATION_IN_MILLISECONDS
    },
    closeSnackbar() {
      return initialState;
    },
  },
});

export const { openSnackbar, closeSnackbar } = snackbarSlice.actions;

export default snackbarSlice.reducer;
